import { render, staticRenderFns } from "./WysiwygEditor.vue?vue&type=template&id=0cbae18f&scoped=true&"
import script from "./WysiwygEditor.vue?vue&type=script&lang=ts&"
export * from "./WysiwygEditor.vue?vue&type=script&lang=ts&"
import style0 from "./WysiwygEditor.vue?vue&type=style&index=0&id=0cbae18f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbae18f",
  null
  
)

export default component.exports